<sales-loader [@fadeInOut] *ngIf="loading$ | async"></sales-loader>
<dgx-ui-wl-sky-header></dgx-ui-wl-sky-header>
<div class="pt-4 my-8 container" [hidden]="hideProgressionSteps(router.url)">
  <dgx-components-progression-steps
    [disableNavigation]="false"
    [steps]="(mobileJourney$ | async) ? mobileSteps : nonMobileSteps"
  ></dgx-components-progression-steps>
</div>

<main class="main-content pb-8">
  <router-outlet></router-outlet>
</main>
<dgx-ui-wl-footer
  [moreLinks]="footerMoreLinks"
  [legalLinks]="footerLegalLinks"
  [usefulLinks]="footerUsefulLinks"
>
  <p>
    Domestic & General Insurance PLC is an insurance undertaking, not an
    intermediary. We are the underwriter of the insurance and do not provide a
    personal recommendation. Domestic & General Services Limited is an appointed
    representative of Domestic & General Insurance PLC, which is authorised by
    the Prudential Regulation Authority and regulated by the Financial Conduct
    Authority and the Prudential Regulation Authority. Sky UK Limited is an
    introducer appointed representative of Domestic & General Insurance PLC,
    which is authorised by the Prudential Regulation Authority and regulated by
    the Financial Conduct Authority and the Prudential Regulation Authority.
  </p>
  <p>
    The Registered office of Domestic & General Services Limited (Company
    Number: 1970780) and Domestic & General Insurance PLC (Company Number:
    485850) is Swan Court, 11 Worple Road, London SW19 4JS. Both Companies are
    registered in England.
  </p>
  <p>
    The Registered office of Sky UK Limited (Company Number: 02906991) in the
    United Kingdom is at: Grant Way, Isleworth, Middlesex TW7 5QD. Sky UK
    Limited is registered in England and Wales.
  </p>
</dgx-ui-wl-footer>
